export const FeatureRequestIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M23.4375 73.4375L25 54.6875H32.8125V43.75C32.8125 39.606 31.1663 35.6317 28.236 32.7015C25.3058 29.7712 21.3315 28.125 17.1875 28.125C13.0435 28.125 9.06921 29.7712 6.13896 32.7015C3.2087 35.6317 1.5625 39.606 1.5625 43.75V54.6875H9.375L10.9375 73.4375H23.4375Z"
        fill="#C4F0EB"
      />
      <path
        d="M17.1875 23.4375C23.2281 23.4375 28.125 18.5406 28.125 12.5C28.125 6.45938 23.2281 1.5625 17.1875 1.5625C11.1469 1.5625 6.25 6.45938 6.25 12.5C6.25 18.5406 11.1469 23.4375 17.1875 23.4375Z"
        fill="#C4F0EB"
      />
      <path
        d="M32.8125 43.75V50C32.8125 45.856 31.1663 41.8817 28.236 38.9515C25.3058 36.0212 21.3315 34.375 17.1875 34.375C13.0435 34.375 9.06921 36.0212 6.13896 38.9515C3.2087 41.8817 1.5625 45.856 1.5625 50V43.75C1.5625 39.606 3.2087 35.6317 6.13896 32.7015C9.06921 29.7712 13.0435 28.125 17.1875 28.125C21.3315 28.125 25.3058 29.7712 28.236 32.7015C31.1663 35.6317 32.8125 39.606 32.8125 43.75V43.75Z"
        fill="white"
      />
      <path
        d="M28.1251 12.5C28.1295 13.5595 27.9714 14.6134 27.6563 15.625C26.9874 13.3676 25.6066 11.3869 23.72 9.97825C21.8334 8.56963 19.542 7.80857 17.1876 7.80857C14.8331 7.80857 12.5417 8.56963 10.6551 9.97825C8.76854 11.3869 7.38781 13.3676 6.71884 15.625C6.4038 14.6134 6.24571 13.5595 6.25009 12.5C6.25009 9.59919 7.40243 6.8172 9.45361 4.76602C11.5048 2.71484 14.2868 1.5625 17.1876 1.5625C20.0884 1.5625 22.8704 2.71484 24.9216 4.76602C26.9727 6.8172 28.1251 9.59919 28.1251 12.5Z"
        fill="white"
      />
      <path
        d="M31.975 38.6934C30.7795 35.1905 28.3792 32.2256 25.2018 30.3272C22.0244 28.4287 18.2762 27.7198 14.6249 28.3268C10.9737 28.9339 7.65647 30.8174 5.26428 33.6419C2.87209 36.4663 1.56027 40.0483 1.5625 43.7497V54.6872H9.375L10.9375 73.4372H23.4375L25 54.6872H28.125"
        stroke="black"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1875 23.4375C23.2281 23.4375 28.125 18.5406 28.125 12.5C28.125 6.45938 23.2281 1.5625 17.1875 1.5625C11.1469 1.5625 6.25 6.45938 6.25 12.5C6.25 18.5406 11.1469 23.4375 17.1875 23.4375Z"
        stroke="black"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.6875 73.4375C58.3959 73.4375 62.021 72.3378 65.1044 70.2776C68.1879 68.2173 70.5911 65.2889 72.0102 61.8628C73.4294 58.4367 73.8007 54.6667 73.0772 51.0296C72.3538 47.3924 70.568 44.0515 67.9458 41.4293C65.3235 38.807 61.9826 37.0213 58.3454 36.2978C54.7083 35.5743 50.9383 35.9456 47.5122 37.3648C44.0861 38.7839 41.1577 41.1871 39.0974 44.2706C37.0372 47.354 35.9375 50.9791 35.9375 54.6875C35.9375 59.6603 37.9129 64.4295 41.4292 67.9458C44.9456 71.4621 49.7147 73.4375 54.6875 73.4375Z"
        fill="#00E6CA"
      />
      <path
        d="M54.6873 35.9375C50.8711 35.9345 47.1449 37.0969 44.0074 39.2694C40.8699 41.4419 38.4707 44.5207 37.1308 48.094C35.7908 51.6672 35.5741 55.5645 36.5096 59.2643C37.4451 62.9641 39.4881 66.2899 42.3654 68.7969L68.7967 42.3656C67.042 40.3467 64.8744 38.7279 62.4402 37.619C60.0061 36.51 57.3622 35.9366 54.6873 35.9375V35.9375Z"
        fill="#C4F0EB"
      />
      <path
        d="M54.6875 73.4375C58.3959 73.4375 62.021 72.3378 65.1044 70.2776C68.1879 68.2173 70.5911 65.2889 72.0102 61.8628C73.4294 58.4367 73.8007 54.6667 73.0772 51.0296C72.3538 47.3924 70.568 44.0515 67.9458 41.4293C65.3235 38.807 61.9826 37.0213 58.3454 36.2978C54.7083 35.5743 50.9383 35.9456 47.5122 37.3648C44.0861 38.7839 41.1577 41.1871 39.0974 44.2706C37.0372 47.354 35.9375 50.9791 35.9375 54.6875C35.9375 59.6603 37.9129 64.4295 41.4292 67.9458C44.9456 71.4621 49.7147 73.4375 54.6875 73.4375Z"
        stroke="black"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.6875 45.3125V64.0625"
        stroke="black"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.0625 54.6875H45.3125"
        stroke="black"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
